import {
  ButtonType,
  CaesarsButton,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useNavigation} from '@react-navigation/native';
import {useDispatch, useSelector} from 'Provider';
import {
  Box,
  Button,
  Divider,
  HStack,
  Pressable,
  VStack,
  View,
} from 'native-base';
import {Text} from 'native-base';
import React, {useCallback, useState} from 'react';
import {Dimensions, SafeAreaView} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import OfferFilter from 'components/Offers/Filters/Filter';
import OfferFilterDate from 'components/Offers/Filters/FilterDates';
import ConnectedOfferFilterDestination from 'containers/OfferFilterDestination';
import ConnectedOfferFilterProperties from 'containers/OfferFilterProperties';
import {Routes} from 'models/Navigation';
import {
  OffersActions,
  SelectedFilters,
  initialSelectedFilters,
} from 'store/offers/offers.reducer';
import {
  availableFiltersSelector,
  offersFilteredSelector,
  selectedFilterSelector,
  shouldApplyFiltersSelector,
} from 'store/offers/offers.selectors';
import {createSortedDestinationsSelector} from 'store/properties/properties.selectors';
import {useTheme} from 'styled-components/native';

const OfferFiltersMobile = () => {
  const destinations = useSelector(createSortedDestinationsSelector);
  const availableFilters = useSelector(availableFiltersSelector);
  const selectedFilters = useSelector(selectedFilterSelector);
  const filteredOffers = useSelector(offersFilteredSelector);
  const hasFiltersApplied = useSelector(shouldApplyFiltersSelector);
  const navigation = useNavigation();
  const [prevSelectedFilters, setPrevSelectedFilters] =
    useState<SelectedFilters>(selectedFilters);

  const theme = useTheme();
  const dispatch = useDispatch();

  const clearFilters = useCallback(() => {
    dispatch(OffersActions.clearFilters());
    setPrevSelectedFilters(initialSelectedFilters);
  }, [dispatch]);

  const onClosePress = useCallback(() => {
    dispatch(OffersActions.setSelectedFilters(prevSelectedFilters));
    navigation.navigate(Routes.Offers.Home);
  }, [dispatch, navigation, prevSelectedFilters]);

  const navigateToDestinations = () => {
    navigation.navigate(Routes.Offers.Destinations);
  };
  const navigateToProperties = () => {
    navigation.navigate(Routes.Offers.Properties);
  };
  const navigateToDates = () => {
    navigation.navigate(Routes.Offers.Dates);
  };
  const navigateToOfferTypes = () => {
    navigation.navigate(Routes.Offers.OfferTypes);
  };
  const onSavePress = () => {
    // Save filters to local state, in case user clicks close and we want to revert
    setPrevSelectedFilters(selectedFilters);
    navigation.navigate(Routes.Offers.Home);
  };
  const selectedDestination = selectedFilters.destination;

  const selectedProperties = selectedFilters.properties;
  const filteredOffersCount = filteredOffers.results.length;

  const handleClearFiltersPressed = () => clearFilters && clearFilters();

  const filteredOffersCountText = (text: string) => {
    const isResult = text.toUpperCase() === 'RESULT';

    if (hasFiltersApplied) {
      if (filteredOffersCount === 1) {
        return isResult ? '1 RESULT' : 'FILTER  (1 OFFER)';
      }
      return isResult
        ? `${filteredOffersCount} RESULTS`
        : `FILTER  (${filteredOffersCount} OFFERS)`;
    }
    return 'FILTER';
  };

  return (
    <Box width={'100%'} height={'100%'} bgColor={'white'}>
      <SafeAreaView
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          justifyContent: 'space-between',
        }}>
        <View>
          <VStack
            justifyContent="center"
            alignContent="center"
            width={'100%'}
            bg="white"
            px={4}>
            <HStack alignItems="flex-start" alignContent="center" py={5}>
              <Icon
                accessibilityLabel="Filter Icon"
                name="sliders-h"
                size={24}
                color={(theme.colors as any).tuna}
                style={{
                  marginRight: theme.space[4],
                  width: 24,
                  textAlign: 'center',
                }}
                solid
              />
              <Text
                accessibilityLabel="Filter heading"
                fontSize={5}
                fontFamily="heading"
                fontWeight={700}
                color="tuna"
                style={{
                  width: Dimensions.get('window').width - 112,
                }}>
                {filteredOffersCountText('result')}
              </Text>
              <Pressable
                accessibilityLabel="Close Filter Menu"
                onPress={onClosePress}>
                <Icon
                  name={'times'}
                  size={24}
                  color={(theme.colors as any).tuna}
                  style={{
                    marginLeft: theme.space[4],
                    width: 24,
                  }}
                  light
                />
              </Pressable>
            </HStack>
          </VStack>
          <Divider bgColor="athens" />
          <VStack
            justifyContent="center"
            alignContent="center"
            width={'100%'}
            bg="white"
            px={4}>
            <ConnectedOfferFilterDestination
              list={destinations}
              onToggle={navigateToDestinations}
              toggle={false}
              selected={selectedDestination}
            />
            {selectedDestination && (
              <>
                <Divider bgColor="athens" />
                <ConnectedOfferFilterProperties
                  list={selectedDestination?.properties ?? []}
                  toggle={false}
                  onToggle={navigateToProperties}
                  selected={selectedProperties}
                  availableProperties={availableFilters.properties}
                />
              </>
            )}
            <Divider bgColor="athens" />
            <OfferFilterDate toggle={false} onToggle={navigateToDates} />
            <Divider bgColor="athens" />
            <OfferFilter
              title="OFFER TYPE"
              isOpen={false}
              onToggle={navigateToOfferTypes}
              icon="tag"
            />
            <Divider bgColor="athens" />
          </VStack>
        </View>
        <HStack
          borderColor="athens"
          space={3}
          borderTopWidth={1}
          height="86px"
          alignItems="center"
          justifyContent="center">
          <CaesarsButton
            type={ButtonType.TEXT_CTA}
            title="Clear Filters"
            onPress={handleClearFiltersPressed}
          />

          <CaesarsButton title="Apply" onPress={onSavePress} />
        </HStack>
      </SafeAreaView>
    </Box>
  );
};

export default OfferFiltersMobile;
